import { render, staticRenderFns } from "./team-list-page.vue?vue&type=template&id=502b8e2c&"
import script from "./team-list-page.vue?vue&type=script&lang=js&"
export * from "./team-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports